// brandPalettes.ts — مصدر ألوان العلامة (مطابق تمامًا لـ frontend/src/theme/smartStableTheme.js)
// مع نظام مجموعات قابل للتبديل من الواجهة، محفوظ في نفس مفتاح localStorage السابق.
export interface BrandTokens {
	page: string;
	card: string;
	cardSoft: string;
	line: string;
	text: string;
	muted: string;
	gold: string;
	goldHover: string;
	goldSoft: string;
	blue: string;
	blueSoft: string;
	green: string;
	greenSoft: string;
	rose: string;
	roseSoft: string;
	warning: string;
	warningSoft: string;
	tableHead: string;
	tableHeadBorder: string;
	appbar: string;
	appbarHover: string;
	ink: string;
	paper: string;
	surface: string;
	sidebarAccent: string;
}

// هوية إسطبل ندرة الحالية (تبقى كما هي).
export const NUDRAH: BrandTokens = {
	page: '#fbfaf7',
	card: '#fffdf8',
	cardSoft: '#f7f3ea',
	line: '#eadfca',
	text: '#4f545c',
	muted: '#7a7f87',
	gold: '#b79b5b',
	goldHover: '#a68847',
	goldSoft: '#efe4cb',
	blue: '#6f8fa6',
	blueSoft: '#eaf2f6',
	green: '#789b82',
	greenSoft: '#edf5ee',
	rose: '#b97878',
	roseSoft: '#f6ecea',
	warning: '#c29355',
	warningSoft: '#f7ead8',
	tableHead: '#c2ad74',
	tableHeadBorder: '#ad9253',
	appbar: '#a68b4d',
	appbarHover: '#b49d6a',
	ink: '#58595b',
	paper: '#f5f2eb',
	surface: '#d5c6a9',
	sidebarAccent: '#252248',
};

// الهوية الجديدة الافتراضية — أخضر داكن + ذهبي + كريمي.
export const SMARTSTABLE: BrandTokens = {
	page: '#faf8f1',
	card: '#fffefb',
	cardSoft: '#f1ece0',
	line: '#e2dac6',
	text: '#21342c',
	muted: '#6f7d75',
	gold: '#a68b4d',
	goldHover: '#8f7740',
	goldSoft: '#ecdfc3',
	blue: '#6f8fa6',
	blueSoft: '#eaf2f6',
	green: '#1f4a3a',
	greenSoft: '#e3ece7',
	rose: '#b35b5b',
	roseSoft: '#f3e3e1',
	warning: '#c29355',
	warningSoft: '#f7ead8',
	tableHead: '#1f4a3a',
	tableHeadBorder: '#163a2d',
	appbar: '#1f4a3a',
	appbarHover: '#173d2f',
	ink: '#21342c',
	paper: '#f1ece0',
	surface: '#e7e0cf',
	sidebarAccent: '#163a2d',
};

export interface BrandPalette {
	key: string;
	name_en: string;
	name_ar: string;
	colors: BrandTokens;
	swatch: string[];
}

export const THEME_PALETTES: Record<string, BrandPalette> = {
	smartstable: {
		key: 'smartstable',
		name_en: 'SmartStable',
		name_ar: 'سمارت ستيبل',
		colors: SMARTSTABLE,
		swatch: [SMARTSTABLE.appbar, SMARTSTABLE.gold, SMARTSTABLE.surface, SMARTSTABLE.paper, SMARTSTABLE.page],
	},
	nudrah: {
		key: 'nudrah',
		name_en: 'Nudrah',
		name_ar: 'ندرة',
		colors: NUDRAH,
		swatch: [NUDRAH.sidebarAccent, NUDRAH.appbar, NUDRAH.surface, NUDRAH.paper, NUDRAH.page],
	},
};

export const DEFAULT_PALETTE_KEY = 'smartstable';
